import React from "react";
import { Node_Type } from "./../ricos-types";
import { TIPTAP_EMBED_TYPE, TIPTAP_LINK_PREVIEW_TYPE } from "./../wix-rich-content-common";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common";
import { selectedNodeResolver } from "./../plugin-commons";
import { linkPreviewModals } from "./consts";
import { TOOLBAR_BUTTON_REPLACE_TO_LINK } from "./dataHooks";
import { SettingsModal } from "./modals/SettingsModal";
import { RemovePreviewButton } from "./toolbar/RemovePreviewButton";
import { LinkPreviewSettingsButton } from "./toolbar/SettingsButton";
const isLinkPreviewSelectedResolver = {
  id: "isLinkPreviewSelected",
  resolve: (content) => {
    if (Array.isArray(content) && content.length > 0) {
      return content[0].type?.name === TIPTAP_LINK_PREVIEW_TYPE;
    } else {
      return false;
    }
  }
};
const getToolbarButtons = (config, services) => {
  const { modals } = services;
  return [
    {
      id: `${Node_Type.LINK_PREVIEW}.replace`,
      dataHook: TOOLBAR_BUTTON_REPLACE_TO_LINK,
      command: ({ editorCommands, attributes: { selectedNode } }) => {
        const link = selectedNode.type.name === TIPTAP_EMBED_TYPE ? selectedNode.attrs.src : selectedNode.attrs.link.url;
        editorCommands.chain().focus().setMeta("allowTextReplace", true).insertContent(link + " ").run();
      },
      attributes: {
        selectedNode: selectedNodeResolver
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(RemovePreviewButton, { toolbarItem })
    },
    {
      id: linkPreviewModals.settings,
      dataHook: "LinkButton",
      command: ({ isMobile, referenceElement, attributes: { selectedNode } }) => {
        const isModalOpen = modals.isModalOpen(linkPreviewModals.settings);
        isModalOpen ? modals.closeModal(linkPreviewModals.settings) : modals.openModal({
          id: linkPreviewModals.settings,
          Component: SettingsModal,
          componentProps: {
            nodeId: selectedNode.attrs.id
          },
          positioning: { placement: "bottom", referenceElement },
          layout: isMobile ? "fullscreen" : "popover",
          noPadding: true
        });
      },
      attributes: {
        selectedNode: selectedNodeResolver,
        visible: isLinkPreviewSelectedResolver
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(LinkPreviewSettingsButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
